import { render, staticRenderFns } from "./BuyerPaymentHistoryList.vue?vue&type=template&id=62c8c4c8"
import script from "./BuyerPaymentHistoryList.vue?vue&type=script&lang=js"
export * from "./BuyerPaymentHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports